// ATtiny85 en 3D: chip DIP-8 de 300 mil (cuerpo de 9.27 × 6.35 mm) con la marca en la cara de arriba y la muesca a la
// izquierda (pin 1 abajo a la izquierda, como los demás DIP).
import { Builder, M, text } from '../kit.js';
import { P, labelPlane } from './actuators-common.js';
import { getPins } from '../../parts/registry.js';

export function buildAttiny85(def, props) {
  const b = new Builder();
  const pins = getPins(def.type, props);
  const len = 4 * P - 0.8;
  b.box(len, 3.3, 6.35, M.chip, 0, 0.9, 0);
  for (const p of pins) {
    const s = Math.sign(p.z);
    b.box(0.55, 0.28, 0.9, M.tin, p.x, 1.85, s * 3.4);
    b.box(1.1, 1.0, 0.28, M.tin, p.x, 1.0, s * 3.81);
    b.box(0.5, 1.2, 0.26, M.tin, p.x, 0, s * 3.81);
  }
  b.build();
  const clock = props.clock === '16pll' ? '16' : '8';
  const top = labelPlane(len, 6.35, `dip8-attiny85-${clock}`, (g, w, d) => {
    g.fillStyle = '#1b1b1e';
    g.fillRect(0, 0, w, d);
    g.fillStyle = '#0f0f11';
    g.beginPath();
    g.arc(0, d / 2, 1.0, -Math.PI / 2, Math.PI / 2);
    g.fill();
    g.beginPath();
    g.arc(1.6, d - 1.3, 0.45, 0, Math.PI * 2);
    g.fill();
    text(g, 'ATTINY85', w / 2 + 0.8, d / 2 - 0.7, { size: 1.45, color: '#acaeb2', weight: 600 });
    text(g, '20PU 1941', w / 2 + 0.8, d / 2 + 1.25, { size: 0.95, color: '#8c8e92', weight: 500 });
  }, { transparent: false, s: 30 });
  top.rotation.x = -Math.PI / 2;
  top.position.y = 4.21;
  b.root.add(top);
  return { root: b.root };
}
